import { useRef, useState, useCallback } from "react";
import { MoveHorizontal } from "lucide-react";

export default function BeforeAfter({ before, after, label }) {
  const containerRef = useRef(null);
  const dragging = useRef(false);
  const [pos, setPos] = useState(50);

  const updateFromClientX = useCallback((clientX) => {
    const el = containerRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    let p = ((clientX - rect.left) / rect.width) * 100;
    p = Math.max(0, Math.min(100, p));
    setPos(p);
  }, []);

  const onMouseDown = (e) => { dragging.current = true; updateFromClientX(e.clientX); };
  const onMouseMove = (e) => { if (dragging.current) updateFromClientX(e.clientX); };
  const stop = () => { dragging.current = false; };

  const onTouchStart = (e) => { dragging.current = true; updateFromClientX(e.touches[0].clientX); };
  const onTouchMove = (e) => { if (dragging.current) updateFromClientX(e.touches[0].clientX); };

  return (
    <div className="select-none">
      <div
        ref={containerRef}
        data-testid="before-after-slider"
        className="relative w-full aspect-[16/10] overflow-hidden rounded-2xl border border-brand-cream cursor-ew-resize shadow-lg"
        onMouseDown={onMouseDown}
        onMouseMove={onMouseMove}
        onMouseUp={stop}
        onMouseLeave={stop}
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={stop}
      >
        {/* After (full) */}
        <img src={after} alt="After" draggable={false} className="absolute inset-0 h-full w-full object-cover pointer-events-none" />
        <span className="absolute bottom-4 right-4 z-10 rounded-full bg-brand-orange px-3 py-1 text-[11px] font-bold uppercase tracking-wider text-white shadow">After</span>

        {/* Before (clipped) */}
        <div className="absolute inset-0 pointer-events-none" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}>
          <img src={before} alt="Before" draggable={false} className="absolute inset-0 h-full w-full object-cover" />
          <span className="absolute bottom-4 left-4 rounded-full bg-brand-dark/85 px-3 py-1 text-[11px] font-bold uppercase tracking-wider text-white shadow">Before</span>
        </div>

        {/* Handle */}
        <div className="absolute top-0 bottom-0 z-20 w-1 -ml-0.5 bg-white pointer-events-none" style={{ left: `${pos}%` }}>
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 grid place-items-center h-11 w-11 rounded-full bg-white shadow-lg ring-2 ring-brand-orange">
            <MoveHorizontal size={18} className="text-brand-orange" />
          </div>
        </div>
      </div>
      {label && <p className="mt-3 text-center text-sm font-medium text-brand-muted">{label} — <span className="text-brand-orange">drag to compare</span></p>}
    </div>
  );
}
